import { Injectable } from "@angular/core";
import { filter, tap, interval, takeWhile, switchMap } from "rxjs";
import { MessageService } from "primeng/api";
import { RoutingNames as routes } from "src/app/shared/enums/routes-names";
import { checkUrl } from "src/app/global";
import { BuildVersionService } from "./build-version.service";

@Injectable()
export class UpToDateBuildService {
  private buildIsUpToDate: boolean;

  public constructor(
    private messageService: MessageService,
    private buildVersionService: BuildVersionService,
  ) {
    this.buildIsUpToDate = true;
    this.checkBuildVersion();
  }

  private get showUpToDate(): boolean {
    const pages = [routes.B2B_OPS, routes.B2B, routes.B2C_PERSONAL_ROOT];
    return pages.some((p) => checkUrl(p));
  }

  private get currentVersion(): string {
    return this.buildVersionService.buildVersionAtStartup;
  }

  private isNewVersion(newVersion: string): boolean {
    return this.showUpToDate && this.buildIsUpToDate && newVersion !== this.currentVersion;
  }

  private checkBuildVersion() {
    const intervalTimer = 1000 * 60; // 1 minute

    interval(intervalTimer)
      .pipe(
        takeWhile(() => this.buildIsUpToDate, false),
        switchMap(() => this.buildVersionService.fetchVersion()),
        filter((newVersion) => this.isNewVersion(newVersion)),
        tap(() => this.showToast()),
      )
      .subscribe();
  }

  private showToast() {
    this.buildIsUpToDate = false;
    const msg = "An update is available. Please refresh this page to get the latest version.";
    this.messageService.add({
      severity: "info",
      summary: "Update Available",
      detail: msg,
      closable: false,
      sticky: true,
    });
  }
}
